import { Button, Flex, Icon, Image, Stack, Text } from "@chakra-ui/react";
import { FiTrash2 } from 'react-icons/fi';

import { useCart } from "../../hooks/cart";
import { formatPrice } from "../../utils/format";

interface PagamentosParams {
	isOpenPayModal: (open: boolean) => void;
}

const Pagamentos: React.FC<PagamentosParams> = ({ isOpenPayModal }) => {
 	const { cart, removeCartPagamento } = useCart();

	return (
		<Flex flexDir="column" mt="6">
			<Stack
				direction="row"
				spacing="4"
				borderBottomWidth={2}
				borderBottomColor='blue.500'
			>
				<Text
					fontSize="20"
					color='blue.500'
					pb="2"
				>
					Pagamento
				</Text>
			</Stack>

			<Flex flexDir="column" py="2">
				<Flex justify="space-between">
					<Text fontWeight="500" color="gray.400">SubTotal</Text>
					<Text fontWeight="500" color="gray.400">{formatPrice(cart.subTotal)}</Text>
				</Flex>

				<Flex justify="space-between">
					<Text fontWeight="500" color="gray.400">Troco</Text>
					<Text fontWeight="500" color="gray.400">{formatPrice(cart.troco)}</Text>
				</Flex>

				<Flex justify="space-between">
					<Text fontWeight="500">Total</Text>
					<Text fontWeight="500">{formatPrice(cart.total)}</Text>
				</Flex>

				<Flex justify="space-between">
					<Text
							fontWeight="500"
							color={cart.falta > 0 ? "gray.900" : "gray.500"}
						>
							Falta
						</Text>
					<Text
						fontWeight="500"
						color={cart.falta > 0 ? "gray.900" : "gray.500"}
					>
						{formatPrice(cart.falta)}
					</Text>
				</Flex>
			</Flex>

			<Flex flexDir="column" py="2">
				{cart.pagamentos && cart.pagamentos.map(pay => {
					return (
						<Flex
							key={pay.id}
							justify="space-between"
							align="center"
							w="100%"
							p="2"
							borderWidth={1}
							borderColor="gray.100"
							borderRadius={8}
						>
							<Stack direction="row" spacing="2" justify="center" align="center">
								<Image w="30" h="25" src={pay.url_pay} alt={pay.name_pay} />
								<Text fontSize={14} fontWeight="500">{pay.name_pay}</Text>
							</Stack>

							<Stack direction="row" spacing="2" justify="center" align="center">
								<Text fontSize={14} fontWeight="500">
									{pay.qtd_parcel}x {formatPrice(pay.vlr_pay)}
								</Text>

								<Flex
									as="button"
									justify="center"
									align="center"
									onClick={() => removeCartPagamento(pay)}
								>
									<Icon
										as={FiTrash2}
										color="red.600"
									/>
								</Flex>
							</Stack>
						</Flex>
					)
				})}
			</Flex>

			<Button
				colorScheme="blue"
        bg="blue.500"
				isDisabled={cart.falta === 0}
				onClick={() => isOpenPayModal(true)}
			>
				Add pagamento
			</Button>
		</Flex>
	)
}

export default Pagamentos;
